/**
 * Resolve a human-readable label for RAG / keyword citation cards.
 * Never returns placeholder values like "Unknown" or "Unknown Document".
 */

const PLACEHOLDER_SOURCES = new Set(['', 'unknown', 'unknown document']);

export interface CitationDisplayFields {
  source?: string;
  artifact_name?: string;
  artifact_filename?: string;
  display_name?: string;
  filename?: string;
  content?: string;
  artifact_id?: string;
  chunk_id?: string;
  index?: number;
}

export function isPlaceholderCitationSource(value?: string | null): boolean {
  if (!value) return true;
  return PLACEHOLDER_SOURCES.has(value.trim().toLowerCase());
}

export function getCitationDisplayLabel(citation: CitationDisplayFields): string {
  const candidates = [
    citation.artifact_name,
    citation.artifact_filename,
    citation.display_name,
    citation.filename,
    citation.source,
  ];

  for (const candidate of candidates) {
    if (!isPlaceholderCitationSource(candidate)) {
      return candidate!.trim();
    }
  }

  const content = citation.content?.trim();
  if (content) {
    const first = content.slice(0, 60).replace(/\s+/g, ' ');
    return first.length < content.length ? `${first}…` : first;
  }

  if (citation.artifact_id) {
    return `Document ${citation.artifact_id.substring(0, 8)}`;
  }

  if (citation.chunk_id) {
    return `Chunk ${citation.chunk_id.substring(0, 8)}`;
  }

  const indexed = `Source ${citation.index ?? ''}`.trim();
  return indexed || 'Source';
}
